import React from 'react';
import LibPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './PhoneInput.scss';

const PhoneInput = ({ onChange, error, label, required, placeholder, value }) => {
  return (
    <div className="text-input-container">
      <div className="text-field-wrapper">
        <label className="">{label}</label>
        <LibPhoneInput
          placeholder={placeholder}
          inputProps={{ required }}
          country={'us'}
          value={value}
          containerClass="phone-input-container"
          inputClass="phone-input"
          onChange={onChange}
        />
        {error && <div className="errorMessage">{error}</div>}
      </div>
    </div>
  );
};

export default PhoneInput;
